import styled from 'styled-components'

import { Container as Card } from '~/components/Card/styles'

export const Container = styled.article`
	min-height: 82vh;

	main {
		padding: 35px 50px 35px 90px;
	
		@media(max-width: 1200px) {
			grid-template-columns: repeat(3, 1fr);
		}

		@media(max-width: 1000px) {
			display: flex;
			flex-direction: column;
			padding: 30px 0;
		}

		${Card} {
			> h1 {
				margin: 16px 24px;
			}

			.react-tabs {
				.react-tabs__tab {
					@media(max-width: 910px) {
						&:not(.react-tabs__tab--selected) {
							display: none;
						}
					}
				}

				.react-tabs__tab-panel {
					background-color: #00000022;
					border-radius: 16px;
					padding: 16px 24px 0;
					min-height: 120px;
				}
			}
		}
	}

	@media(max-width: 914px) {
		display: flex;
		flex-direction: column;
		padding-bottom: 30px;
	}
`

export const ExpanderTab = styled.div`
	display: none;
	padding: 6px;
	background-color: #0001;
	border-radius: 50%;
	margin: 2px 8px;
	transition: 300ms;

	&:hover {
		cursor: pointer;
		background-color: #0002;
	}

	.expander-tab {
		height: 100%;
		display: flex;
		align-items: center;
	}

	@media(max-width: 910px) { 
		display: inline-block;		
	}
`

export const ImageSelect = styled.div`
	height: 350px;
	display: ${props => props.academico === null ? 'block' : 'none'};

	.medico {
		position: absolute;
		margin-left: auto;
		margin-right: auto;
		left: 100px;
		right: 0;
		height: 315px;
		transition: 300ms;

		&:hover {
			transform: scale(1.05);
			cursor: pointer;
		}
	}

	.academica {
		position: absolute;
		margin-left: auto;
		margin-right: auto;
		left: -120px;
		right: 0;
		height: 300px;
		margin-top: 16px;
		transition: 300ms;

		&:hover {
			transform: scale(1.05);
			cursor: pointer;
		}
	}
`
